import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { TextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/text-input-control";
import { Input } from "@h3/antd-vue";
import H3Textarea from "@cloudpivot/form/src/common/components/h3-textarea.vue";
import MutilText from "@cloudpivot/form/src/common/components/mutil-text.vue";
let PcInputText = class PcInputText extends TextInputControl {
    onKeydown(evt) {
        const key = evt.key.toLowerCase();
        if (key !== "delete" && key !== "backspace") {
            if (this.ctrl.value && this.ctrl.value.length > this.maxLength) {
                evt.preventDefault();
            }
        }
    }
    onKeyup() {
        if (this.ctrl.value && this.ctrl.value.length > this.maxLength) {
            const val = this.ctrl.value.substr(0, this.maxLength);
            this.setValue(val);
        }
    }
    onBlur() {
        super.validate();
    }
    onChange() {
        const val = this.val.length === 0 ? null : this.val;
        this.setValue(val);
    }
};
PcInputText = tslib_1.__decorate([
    Component({
        name: "pc-input-text",
        components: {
            AInput: Input,
            // ATextarea: Input.TextArea,
            H3Textarea,
            MutilText
        }
    })
], PcInputText);
export default PcInputText;
